interface HeaderSectionProps {
  firstName: string;
}

export function HeaderSection({ firstName }: HeaderSectionProps) {
  return (
    <div className="text-center mb-8 sm:mb-12">
      <h1 
        className="text-4xl sm:text-5xl md:text-6xl mb-3 sm:mb-4"
        style={{ 
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic',
          color: '#1D1D1D',
          fontWeight: 400
        }}
      >
        Hey {firstName}!
      </h1>
      <h2 
        className="text-xl sm:text-2xl md:text-3xl mb-3 sm:mb-4"
        style={{ 
          fontFamily: 'Inter, sans-serif',
          color: '#1D1D1D',
          fontWeight: 400
        }}
      >
        Welcome to Profound
      </h2>
      <p 
        className="text-base sm:text-lg text-gray-700 max-w-2xl mx-auto"
        style={{ 
          fontFamily: 'Inter, sans-serif',
          lineHeight: '1.5'
        }}
      >
        We&apos;ve already got a solid start, thanks for sharing your LinkedIn profile. Here&apos;s what we know about you so far
      </p>
    </div>
  );
}

